import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/home',
    name: 'home',
    meta: {
      title: '营养健康服务',
    },
    component: () => import('@/views/home'),
  },

  // 山大一问卷调查
  {
    path: '/vm/weLvLfc',
    name: 'weLvLfc',
    meta: {
      title: '在线健康问卷',
    },
    component: () => import('@/views/shandayi/healthQuestionnaire'),
  },
  {
    path: '/p/p',
    name: 'prescriptionPayment',
    meta: {
      title: '营养健康服务',
    },
    component: () => import('@/views/prescription/prescriptionPayment'),
  },
  {
    path: '/prescription/prescriptionPayments',
    name: 'prescriptionPayments',
    meta: {
      title: '营养健康服务',
    },
    component: () => import('@/views/prescription/prescriptionPayments'),
  },
  // 暨南大学膳食医嘱
  {
    path: '/jndx/prescription/prescriptionPayments',
    name: 'jndxPrescriptionPayments',
    meta: {
      title: '营养健康服务',
    },
    component: () =>
      import('@/views/prescription/jinanHospital/jndxPrescriptionPayments'),
  },
  // 和平
  {
    path: '/heping/prescriptionPayments',
    name: 'hepingPrescriptionPayments',
    meta: {
      title: '营养健康服务',
    },
    component: () => import('@/views/hepingHospital/prescriptionPayments'),
  },

  // 暨南大学
  {
    path: '/pre/jndx',
    name: 'jinanHospitalPrescriptionPayments',
    meta: {
      title: '营养健康服务',
    },
    component: () =>
      import('@/views/prescription/jinanHospital/prescriptionPayments'),
  },

  // 暨南大学第一附属医院预交费
  {
    path: '/pre/jndx/yjf',
    name: 'advancePayment',
    meta: {
      title: '营养健康服务',
    },

    component: () =>
      import('@/views/prescription/jinanHospital/advancePayment'),
  },
  // 暨南大学订单列表
  {
    path: '/order',
    name: 'jinanHospitalorderList',
    meta: {
      title: '健康营养',
    },
    component: () => import('@/views/prescription/jinanHospital/orderList'),
  },
  // 宝丰预缴费
  {
    path: '/pre/bfyy/yjf',
    name: 'baofengAdvancePayment',
    meta: {
      title: '宝丰县人民医院',
    },
    component: () =>
      import('@/views/prescription/baofengHospital/advancePayment'),
  },

  // 山西省人民医院预交费
  {
    path: '/pre/sxsrmyy/yjf',
    name: 'advanceSxsrmyyPayment',
    meta: {
      title: '山西省人民医院',
    },
    component: () => import('@/views/prescription/shengrenming/depositPayment'),
  },
  // 省人民授权页面
  {
    path: '/pre/srm',
    name: 'auth',
    meta: {
      title: '营养健康服务',
    },
    component: () => import('@/views/prescription/shengrenming/auth'),
  },
  // 省人民支付页
  {
    path: '/pre/srm/pay',
    name: 'srmPrescriptionPayments',
    meta: {
      title: '营养健康服务',
    },
    component: () =>
      import('@/views/prescription/shengrenming/prescriptionPayments'),
  },
  // 微信支付公共页
  {
    path: '/pre/wechatPay',
    name: 'wechatPayPrescriptionPayments',
    meta: {
      title: '营养健康服务',
    },
    component: () => import('@/views/prescription/weChat/prescriptionPayments'),
  },
  // 内网微信支付公共页
  {
    path: '/p/p/wechatPay',
    name: 'intranetWechatPayPrescriptionPayments',
    meta: {
      title: '营养健康服务',
    },
    component: () =>
      import('@/views/prescription/weChat/intranetWechatPrescriptionPayments'),
  },
  // 钟祥妇幼支付页
  {
    path: '/pre/zxfy/pay',
    name: 'srmPrescriptionPayments',
    meta: {
      title: '营养健康服务',
    },
    component: () =>
      import('@/views/prescription/zhongxiang/prescriptionPayments'),
  },
  // 钟祥妇幼预交费支付页
  {
    path: '/pre/zxfy/yjf',
    name: 'advanceSxsrmyyPayment',
    meta: {
      title: '山西省人民医院',
    },
    component: () => import('@/views/prescription/zhongxiang/depositPayment'),
  },

  {
    path: '/p/g',
    name: 'prescriptionGoodsPayment',
    meta: {
      title: '营养健康服务',
    },
    component: () => import('@/views/prescription/prescriptionGoodsPayment'),
  },

  {
    path: '/p/w',
    name: 'prescriptionPaymentNoWifi',
    meta: {
      title: '营养健康服务',
    },
    component: () => import('@/views/prescription/prescriptionPaymentNoWifi'),
  },
  {
    path: '/p/d',
    name: 'prescriptionDeptGoodsPayment',
    meta: {
      title: '营养健康服务',
    },
    component: () =>
      import('@/views/prescription/prescriptionDeptGoodsPayment'),
  },
  {
    path: '/p/jlsetyy',
    name: 'jlsetyy',
    meta: {
      title: '吉林市儿童医院',
    },
    component: () =>
      import('@/views/prescription/hospital/prescriptionHospitalScanPayment'),
  },
  {
    path: '/p/jlccdsyy',
    name: 'jlccdsyy',
    meta: {
      title: '长春中医药大学附属第三临床医院',
    },
    component: () =>
      import(
        '@/views/prescription/hospital/prescriptionHospitalScanPaymentCCDSYY'
      ),
  },
  {
    path: '/prescription/hospitalOrders',
    name: 'hospitalOrders',
    meta: {
      title: '订单列表',
    },
    component: () => import('@/views/prescription/hospitalOrders'),
  },
  {
    path: '/prescription/cczyydadsHospitalOrders',
    name: 'cczyydadsHospitalOrders',
    meta: {
      title: '长春中医药大学附属第三临床医院订单列表',
    },
    component: () =>
      import('@/views/prescription/orders/cczyydadsHospitalOrders'),
  },
  {
    path: '/prescription/orders/zhxHospitalOrders',
    name: 'zhxHospitalOrders',
    meta: {
      title: '赞皇县订单列表',
    },
    component: () => import('@/views/prescription/orders/zhxHospitalOrders'),
  },
  {
    path: '/prescription/orders/jxHospitalOrders',
    name: 'jxHospitalOrders',
    meta: {
      title: '吉县订单列表',
    },
    component: () => import('@/views/prescription/orders/jxHospitalOrders'),
  },
  {
    path: '/prescription/orders/jlsetyyHospitalOrders',
    name: 'jlsetyyHospitalOrders',
    meta: {
      title: '吉林市儿童医院订单列表',
    },
    component: () =>
      import('@/views/prescription/orders/jlsetyyHospitalOrders'),
  },
  {
    path: '/prescription/orders/jzszyyHospitalOrders',
    name: 'jzszyyHospitalOrders',
    meta: {
      title: '中医订单列表',
    },
    component: () => import('@/views/prescription/orders/jzszyyHospitalOrders'),
  },
  {
    path: '/prescription/invoice',
    name: 'invoice',
    meta: {
      title: '开具发票',
    },
    component: () => import('@/views/invoice/invoice'),
  },
  {
    path: '/prescription/usage',
    name: 'usage',
    meta: {
      title: '用法用量',
    },
    component: () => import('@/views/prescription/prescriptionUsage'),
  },
  {
    path: '/propagate/propagateList/:id',
    name: 'propagateList',
    meta: {
      title: '宣教医嘱',
    },
    component: () => import('@/views/propagate/propagateList'),
  },
  {
    path: '/propagate/propagateDetails/:id',
    name: 'propagateDetails',
    meta: {
      title: '宣教详情',
    },
    component: () => import('@/views/propagate/propagateDetails'),
  },
  {
    path: '/dietaryguidance/dietaryguidanceDetail/:id',
    name: 'dietaryguidance',
    meta: {
      title: '膳食指导方案',
    },
    component: () => import('@/views/dietaryguidance/dietaryguidanceDetail'),
  },
  {
    path: '/dietaryguidance/dietTreatment',
    name: 'dietTreatment',
    meta: {
      title: '治疗膳食',
    },
    component: () => import('@/views/dietaryguidance/dietTreatment'),
  },
  {
    path: '/nutrition/diet/guidance/:id',
    name: 'guidance',
    meta: {
      title: '膳食套餐',
    },
    component: () => import('@/views/guidance/guidance'),
  },
  {
    path: '/nutrition/diet/guidanceDetails/:id',
    name: 'guidanceDetails',
    meta: {
      title: '套餐详情',
    },
    component: () => import('@/views/guidance/guidanceDetails'),
  },
  {
    path: '/bookOrder/:orgId',
    name: 'bookOrder',
    meta: {
      title: '点餐支付',
    },
    component: () => import('@/views/orderingFood/bookOrder'),
  },
  {
    path: '/bookOrder/mealsList',
    name: 'mealsList',
    meta: {
      title: '餐品列表',
      // keepAlive: true
    },
    component: () => import('@/views/orderingFood/mealsList'),
  },
  {
    path: '/bookOrder/mealsDetails',
    name: 'mealsDetails',
    meta: {
      title: '餐品详情',
    },
    component: () => import('@/views/orderingFood/mealsDetails'),
  },
  {
    path: '/bookOrder/reserveList',
    name: 'reserveList',
    meta: {
      title: '预定列表',
    },
    component: () => import('@/views/orderingFood/reserveList'),
  },
  {
    path: '/bookOrder/mealsOrderDetails',
    name: 'mealsOrderDetails',
    meta: {
      title: '订单详情',
    },
    component: () => import('@/views/orderingFood/mealsOrderDetails'),
  },
  {
    path: '/bookOrder/orderPay',
    name: 'orderPay',
    meta: {
      title: '支付页',
    },
    component: () => import('@/views/orderingFood/orderPay'),
  },
  {
    path: '/bookOrder/mealsOrderList',
    name: 'mealsOrderList',
    meta: {
      title: '全部订单',
    },
    component: () => import('@/views/orderingFood/mealsOrderList'),
  },
  {
    path: '/wechatPay',
    name: 'wechatPay',
    meta: {
      title: '支付',
    },
    component: () => import('@/views/wechatPage/index'),
  },
  // 平遥订单记录
  {
    path: '/pingyao/orderRecord',
    name: 'pingyaoPrderRecord',
    meta: {
      title: '订单记录',
    },
    component: () => import('@/views/reportForms/pingyaoOrderRecord'),
  },
  // 长沙太和订单记录
  {
    path: '/changshataihe/orderRecord',
    name: 'csthPrderRecord',
    meta: {
      title: '订单记录',
    },
    component: () => import('@/views/reportForms/changshataiheOrderRecord'),
  },
  // 凤城订单记录
  {
    path: '/fengcheng/orderRecord',
    name: 'fengchengOrderRecord',
    meta: {
      title: '订单记录',
    },
    component: () => import('@/views/reportForms/fengchengOrderRecord'),
  },
  // 省人民订单记录
  {
    path: '/srm/orderRecord',
    name: 'srmOrderRecord',
    meta: {
      title: '订单记录',
    },
    component: () => import('@/views/reportForms/srmOrderRecord'),
  },
  // 山西医科大订单记录
  {
    path: '/sxykd/orderRecord',
    name: 'yikedaOrderRecord',
    meta: {
      title: '订单记录',
    },
    component: () => import('@/views/reportForms/yikedaOrderRecord'),
  },
  // 高陵医院
  {
    path: '/gl/orderRecord',
    name: 'gaolingOrderRecord',
    meta: {
      title: '订单记录',
    },
    component: () => import('@/views/reportForms/gaolingOrderRecord'),
  },
  // 杏花岭中心医院订单记录
  {
    path: '/xhl/orderRecord',
    name: 'xhlOrderRecord',
    meta: {
      title: '订单记录',
    },
    component: () => import('@/views/reportForms/xhlzxOrderRecord'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  // 动态添加浏览器title
  window.document.title = to.meta.title
  next()
})

export default router
